/*
==========================================
店舗在庫確認用処理 (for Product page)
==========================================
*/

document.addEventListener('DOMContentLoaded', () => {
  const productFavoriteInStoreStockList = document.querySelectorAll('.item-store-stock__opener-wrapper .product-form__favorite');
  if(productFavoriteInStoreStockList.length > 0){
    productFavoriteInStoreStockList.forEach((productFavorite) => {
      productFavorite.addEventListener('click', () => {
        document.querySelector('.product__addBtnSp').click();
      })
    });
  }
  // --------------------------------------------------
  // モーダル表示・非表示
  // --------------------------------------------------
  const storeStockModal = document.querySelector('.item-store-stock-modal');
  const modalTriggers = document.querySelectorAll(
    '.item-store-stock-modal__overlay, .item-store-stock-modal__close, .item-store-stock-modal__bottom-close, [data-store-stock-modal-trigger]'
  );


  const animationDuration = 500;

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (storeStockModal.classList.contains('is-show')) {
        // モーダルを非表示にする場合ß
        storeStockModal.animate([{ opacity: '1' }, { opacity: '0' }], {
          duration: animationDuration,
          easing: 'ease-in-out',
          fill: 'forwards',
        }).onfinish = () => {
          storeStockModal.style.display = 'none';
          storeStockModal.classList.toggle('is-show');
        };
      } else {
        // モーダルを表示する場合
        // storeStockModal.style.opacity = 0;
        storeStockModal.style.display = 'block';
        storeStockModal.classList.toggle('is-show');
        storeStockModal.animate([{ opacity: '0' }, { opacity: '1' }], {
          duration: animationDuration,
          easing: 'ease-in-out',
          fill: 'forwards',
        });
      }
    });
  });

  // --------------------------------------------------
  // 店舗在庫確認ボタン
  // --------------------------------------------------
  const mountStoreStockAccordion = () => {
    document.querySelectorAll('[data-store-stock-accordion-opener]')
    .forEach((accordion) => {
      accordion.addEventListener('click', function() {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        
        if (this.classList.contains('active')) {
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.style.maxHeight = 0;
        }
      });
    });
  }
  mountStoreStockAccordion();


  // --------------------------------------------------
  // 店舗一覧取得
  // --------------------------------------------------
  let storeListByArea = null;
  if (document.getElementById("store-list-information")) {
    /**
     * @typedef {Object} StoreInformation
     * @property {string} store_area - The area of the store.
     * @property {string} shop_url - The Shop page link for the store.
     * @property {number} area_order - The sort order of the store.
     * @property {string} store_name - The name of the store.
     */

    /**
     * 店舗情報の配列
     * @type {StoreInformation[]}
     */
    const storeListInformation = JSON.parse(
      document.getElementById("store-list-information").textContent
    );
    if(storeListInformation){
      storeListByArea = storeListInformation.reduce((acc, store) => {
        if (!acc[store.store_area]) {
          acc[store.store_area] = [];
        }
        acc[store.store_area].push(store);
        return acc;
      }, {});

      for (const store_area in storeListByArea) {
        storeListByArea[store_area].sort((a, b) => a.area_order - b.area_order);
      }

    }
  }
});
